<template>
  <div class="insights-meetings-widget-dialog-insights">
    <div class="title">Meetings insights</div>

    <AppChartRange
      v-if="hasData"
      :items="items"
    />
    <div v-else>No data available.</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppChartRange from '~/components/AppChartRange.vue';

export default {
  name: 'InsightsMeetingsDialogInsights',
  components: {
    AppChartRange,
  },
  computed: {
    ...mapGetters(['meetings']),
    hasData() {
      return this.meetings.averages?.length;
    },
    items() {
      const data = [];

      if (this.hasData) {
        this.meetings.averages.forEach((item) => {
          const {
            label,
            unit,
            value,
            tooltip,
            min_value: minValue,
            max_value: maxValue,
            average_min: averageMin,
            average_max: averageMax,
          } = item;

          data.push({
            label,
            unit,
            tooltip,
            values: {
              value,
              minValue,
              maxValue,
              averageMin,
              averageMax,
            },
          });
        });
      }

      return data;
    },
  },
};
</script>
